import React from "react";
import {Typography} from "@mui/material";

import {buildHealthIndicatorIcon, buildSessionHealthColor} from "../../../helpers/HealthIndicatorBuilder";
import ZoomMeetingRecording from "../../availability/ZoomMeetingRecording";
import {CenteredBox, ColoredAvatar} from "../../themes/styled";

export default function RecordingAvailableHealth({session, state}) {

    const defaultOptions = {displayMeetingId: true};

    const backgroundColor = buildSessionHealthColor[state];
    const icon = buildHealthIndicatorIcon("recordings-available");
    
    const {lessonRecordingStatus, zoomMeetingRecordingUrls, zoomMeetingUrl} = session;

    return (
      <CenteredBox>
          <ColoredAvatar background={backgroundColor}>{icon}</ColoredAvatar>
          <Typography variant="body2" sx={{mr: '-0.75rem'}}>Recordings ready</Typography>
          {
            state === "SUCCESS"
            && <ZoomMeetingRecording
              recordingStatus={lessonRecordingStatus}
              recordingUrls={zoomMeetingRecordingUrls}
              zoomMeetingUrl={zoomMeetingUrl}
              options={defaultOptions}/>
          }
      </CenteredBox>
    );
}